import cookie from 'js-cookie';

import { WEBSITE_TOKEN_COOKIE } from './constants';

export function removeTokenCookie() {
  cookie.remove(WEBSITE_TOKEN_COOKIE);
}
